import { makeStyles } from '../../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    rangeButton: {
        justifyContent: 'flex-start',
        fontWeight: 400,
        color: theme.colors.text[900],
    },
    activeRangeButton: {
        fontWeight: 600,
        color: theme.colors.primary.main,
    },
}));
//# sourceMappingURL=RangesList.styles.js.map